module.exports = __webpack_public_path__ + "static/media/footrest.4165c66c.svg";